const EmptyState = ({ message }) => {
  return (
    <div className="bg-white p-6 rounded-xl text-center text-gray-500 shadow">
      <p>{message}</p>
    </div>
  );
};

export default EmptyState;
